import React from "react";
import classnames from "classnames";
import ContentLoader from "react-content-loader";
import styles from "./FormInputLoader.module.scss";

const IasFormInputLoader = ({ hide }) => {
  return (
    <div
      className={classnames(styles.FormInputLoader, { [styles.hide]: hide })}
    >
      <ContentLoader
        speed={2}
        width={"100%"}
        height={"2.375rem"}
        backgroundColor={"#f3f3f3"}
        foregroundColor={"#ecebeb"}
      >
        <rect x="0" y="10" rx="3" ry="3" width="8.5rem" height="1.25rem" />
        <rect x="160" y="0" rx="3" ry="3" width="100%" height="2.375rem" />
      </ContentLoader>
    </div>
  );
};

export default IasFormInputLoader;
